import membershipPrivileges from 'helpers/membership_privileges';

angular
  .module 'filters'
  .filter 'membershipPrivileges', ->
    (membership) ->
      membershipPrivileges(membership)
